import React, { useMemo, useRef } from 'react';
import { Button } from '@mui/material';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';

type ScanBadgeButtonProps = {
  onScan?: (badgeId: string) => void;
  loading?: boolean;
  disabled?: boolean;
};

export const ScanBadgeButton: React.FC<ScanBadgeButtonProps> = ({ onScan, loading, disabled }) => {
  // PeopleSync-synced Individual IDs with complete personnel data (rank, unit, MOS, billet, position)
  const seededBadgeIds = useMemo(
    () => ['1948975701', '7971473857', '1120005095', '2756247191', '438961033'],
    [],
  );
  const nextIndexRef = useRef(0);

  const handleClick = () => {
    // Simulate scanning by cycling through known PeopleSync-synced Individual IDs when hardware is unavailable
    // In production, this would integrate with CAC card reader hardware
    const scannedId = seededBadgeIds[nextIndexRef.current];
    nextIndexRef.current = (nextIndexRef.current + 1) % seededBadgeIds.length;
    if (scannedId) {
      onScan?.(scannedId);
    }
  };

  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={<QrCodeScannerIcon />}
      onClick={handleClick}
      disabled={disabled || loading}
      aria-label="Scan badge to identify customer"
    >
      {loading ? 'Scanning…' : 'Scan Badge'}
    </Button>
  );
};
